import type { ReactElement, SVGProps } from "react";

export function CartItemIcon(props: SVGProps<SVGSVGElement>): ReactElement {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.46545 21.8C4.82628 21.8 4.28895 21.5822 3.85345 21.1465C3.41778 20.711 3.19995 20.1737 3.19995 19.5345V8.9655C3.19995 8.32633 3.41778 7.789 3.85345 7.3535C4.28895 6.91783 4.82628 6.7 5.46545 6.7H7.29995C7.29995 5.38583 7.75637 4.274 8.6692 3.3645C9.58187 2.45483 10.6921 2 12 2C13.3078 2 14.418 2.45642 15.3307 3.36925C16.2435 4.28192 16.7 5.39217 16.7 6.7H18.5345C19.1736 6.7 19.711 6.91783 20.1465 7.3535C20.5821 7.789 20.8 8.32633 20.8 8.9655V19.5345C20.8 20.1737 20.5821 20.711 20.1465 21.1465C19.711 21.5822 19.1736 21.8 18.5345 21.8H5.46545ZM12 14.1C13.3078 14.1 14.418 13.6436 15.3307 12.7308C16.2435 11.8181 16.7 10.7078 16.7 9.4H15.05C15.05 10.25 14.7531 10.9708 14.1595 11.5625C13.5658 12.1542 12.845 12.45 11.997 12.45C11.149 12.45 10.4291 12.1535 9.83745 11.5605C9.24578 10.9673 8.94995 10.2472 8.94995 9.4H7.29995C7.29995 10.7142 7.75637 11.826 8.6692 12.7355C9.58187 13.6452 10.6921 14.1 12 14.1ZM8.94995 6.7H15.05C15.05 5.85 14.7531 5.12917 14.1595 4.5375C13.5658 3.94583 12.845 3.65 11.997 3.65C11.149 3.65 10.4291 3.9465 9.83745 4.5395C9.24578 5.13267 8.94995 5.85283 8.94995 6.7Z"
        fill="#7E82AD"
      />
    </svg>
  );
}
